module.exports = __webpack_public_path__ + "static/img/Matt-Burton.e575ff7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Matt-Burton.jpg
// module id = NlvG
// module chunks = 0